import { dynamic } from '@unifyapps/carbon/external/dynamic';
import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import type { TagComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';

const importTagComponent = () =>
  import(
    /* webpackChunkName: "tag-block" */
    './Tag'
  );

// adding loading: () => null such that nearest <Suspense /> is not triggered when the block is loading
const Tag = dynamic(importTagComponent, { loading: () => null });

class TagBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  get type(): ComponentTypeUnionType {
    return 'Tag';
  }

  get initialStateGetter() {
    return (block: BlockType) => ({
      id: block.id,
      ..._pick(block.component as TagComponentType, ['content', 'appearance', 'componentType']),
    });
  }

  getComponent() {
    return Tag;
  }

  preload() {
    return {
      blockPreload: importTagComponent,
    };
  }
}

export default TagBlockStateDefinition;
